import { render, staticRenderFns } from "./nuevalistapromotor.vue?vue&type=template&id=2e330b8f&scoped=true&"
import script from "./nuevalistapromotor.vue?vue&type=script&lang=js&"
export * from "./nuevalistapromotor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e330b8f",
  null
  
)

export default component.exports